import { observable, makeObservable, action, runInAction } from 'mobx';

import { HttpClient, LoadStatuses } from '../utils/HttpClient';

export type BackupClientIds = 'smartlog.cloud' | 'smartlog.mobile' | 'smartlog.desktop';

export interface Backup {
  backupDate: number;
  backupId: BackupClientIds;
  dmsClientId: string;
  restoreDate: number;
}

export enum BackupErrorTypes {
  permission_required = 'permission_required',
  vessel_access_denied = 'vessel_access_denied',
}

class BackupStore {
  backup: Backup = null;
  initializeStatus: LoadStatuses = 'inital';
  errorType: BackupErrorTypes = null;

  constructor() {
    makeObservable(this, {
      backup: observable,
      initializeStatus: observable,

      initialize: action,
    });
  }

  initialize = async () => {
    runInAction(() => {
      this.initializeStatus = 'loading';
      this.errorType = null;
    });
    try {
      const backup = await HttpClient.SmartLogCloud.POST('/backup/init');
      runInAction(() => {
        this.initializeStatus = 'loaded';
        this.backup = backup;
      });
    } catch (e: any) {
      runInAction(() => {
        this.initializeStatus = 'error';
        this.errorType = e?.responseJSON?.errorType;
      });
    }
  };
}

export const backupStore = new BackupStore();
